import { BackgroundVisitUploadStatus } from "@/common/enums/backgroundVisitUploadStatus";
import { useVisitScope } from "@/lib/visit-queries";
import {
  isBackgroundUploadVisible,
  useBackgroundVisitUploadStore,
} from "@/store/backgroundVisitUpload.store";

export const useBackgroundVisitStatus = (): {
  unfinishedCount: number;
  /** Uploads whose audio has not reached the server, including failed ones. */
  unsentCount: number;
  isUploading: boolean;
} => {
  const allUploads = useBackgroundVisitUploadStore((state) => state.uploads);
  const scope = useVisitScope();
  const uploads = allUploads.filter((upload) =>
    isBackgroundUploadVisible(upload, scope),
  );

  const unfinishedCount = uploads.filter(
    (upload) =>
      upload.status === BackgroundVisitUploadStatus.PENDING ||
      upload.status === BackgroundVisitUploadStatus.UPLOADING,
  ).length;

  const unsentCount = uploads.filter(
    (upload) =>
      upload.status === BackgroundVisitUploadStatus.PENDING ||
      upload.status === BackgroundVisitUploadStatus.UPLOADING ||
      upload.status === BackgroundVisitUploadStatus.FAILED,
  ).length;

  const isUploading = uploads.some(
    (upload) => upload.status === BackgroundVisitUploadStatus.UPLOADING,
  );

  return { unfinishedCount, unsentCount, isUploading };
};
